module.exports = __webpack_public_path__ + "static/media/congratulations.7e1d0d15.mp3";